// Material Dashboard 2 PRO React TS Base Styles
import borders from 'assets/theme-dark/base/borders';
import boxShadows from 'assets/theme-dark/base/boxShadows';
import colors from 'assets/theme-dark/base/colors';

// types
type Types = any;

const { borderRadius } = borders;
const { xxl } = boxShadows;
const { background } = colors;

const dialog: Types = {
    styleOverrides: {
        paper: {
            borderRadius: borderRadius.lg,
            boxShadow: xxl,
            background: background.card,
        },

        paperFullScreen: {
            borderRadius: 0,
        },
    },
};

export default dialog;
